const RESOURCE_TYPE = 'WM_EBANK';

function parseResult(res) {
  if(!res){
    return null;
  }
  return JSON.stringify(res);
}

function parseEntitlementUserPf(result) {
  if(Object.keys(result.entitlementUser).length === 0) {
    const isUserEntitlement = { 'entitlementUser' : ''};
    return JSON.stringify(isUserEntitlement);
  } else {
    const isUserEntitlement = { 'entitlementUser' : { 'portfolios': {'modules' : []}}};
    return JSON.stringify(isUserEntitlement);
  }
}

function parseUserEntitlement(userEntitlement, resourceId) {
  const entitlement = userEntitlement.resourceActionModel || [];

  let resourceEntitlement = entitlement
    .find((resource) => (
      resource.resourceName.type === RESOURCE_TYPE &&
      (resource.resourceName.id.toLowerCase() === resourceId.toLowerCase() ||
      (resource.resourceName.id.toLowerCase() === 'dashboard' &&
        resourceId.toLowerCase() === 'portfolio'))
    ));

  if(resourceId.toLowerCase() == 'insight'){
    resourceEntitlement = entitlement
      .find((resource) => (
        resource.resourceName.type === RESOURCE_TYPE &&
        (resource.resourceName.id.toLowerCase().includes('insight') )
      ));
  }

  if (!resourceEntitlement) {
    return false;
  }

  return true;
}


function parseEntitlementList(userEntitlement){
  const entitlementList = userEntitlement.resourceActionModel || [];
  const modules = userEntitlement.modules || [];
  let returnEntitlementList = {};
  let returnModules = [];

  entitlementList.map(function(item) {

    returnEntitlementList[item.resourceName.id.toLowerCase()] = true;

  });
  modules.map(function(item) {
    returnModules.push(item.toLowerCase());
  });

  returnEntitlementList.roles = userEntitlement.roles;
  returnEntitlementList.userGroup = userEntitlement.userGroup || null;
  return Object.assign( {}, returnEntitlementList, { modules : returnModules })
}



function parseUserInsightRoles(userEntitlement){

  const entitlementList = userEntitlement.resourceActionModel || [];
  var insightsRole = [];


  entitlementList.map(function(item) {

    var roleID = item.resourceName.id.toLowerCase();
    var hasInsight =  roleID.indexOf("insight") !== -1;

    if(hasInsight){
      insightsRole.push(item.resourceName.id);
    }

  });
  return insightsRole.toString();

}

function parseEntitlementsforRM(data){
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}


function serviceFactory({ api }) {

  const getUserEntitlement = (resourceId, metaData) =>
    api.getUserEntitlement(metaData).then((userEntitlement) =>
      parseUserEntitlement(userEntitlement, resourceId));

  const getUserEntitlementList = (metaData) =>
    api.getUserEntitlement(metaData).then((userEntitlement) =>
      parseEntitlementList(userEntitlement));

  const getUserInsightRoles = (metaData) =>
    api.getUserEntitlement(metaData).then((userEntitlement) =>
      parseUserInsightRoles(userEntitlement));

  const getPaymentAvailableCheck = (metaData) =>
    api.getPaymentAvailableCheck(metaData).then((paymentCheck) =>
      parseResult(paymentCheck));

  const getEntitlementUserPfList = (metaData) =>
    api.getEntitlementUserPfList(metaData).then((entitlementUserPf) =>
      parseEntitlementUserPf(entitlementUserPf));

  const getEntitlementsforRM = ({ inputParam, metaData }) =>
    api.getEntitlementsforRM(inputParam, metaData).then((entitlementRM) =>
     parseEntitlementsforRM(entitlementRM));


  return { getUserEntitlement,getUserEntitlementList, getUserInsightRoles, getPaymentAvailableCheck, getEntitlementUserPfList, getEntitlementsforRM };
}

module.exports = serviceFactory;
